/* Peter and May - country / language selectors (footer + mobile drawer).
   Both blocks style the localization form as a bare <select> instead of Dawn's
   <localization-form> disclosure, so assets/localization-form.js never sees
   them : it looks for input[name="locale_code"] plus a button, and our markup
   has neither. Without this file the only way to commit a choice is the
   <noscript> submit button, i.e. never for a real visitor - the select changes
   and the page stays put.
   Delegated on the document : the theme editor re-renders the footer section
   and the drawer snippet on every setting change, and a delegated listener
   survives that without a re-bind. */
(() => {
  const FORMS = '.pm-footer__locale-form, .pm-mobile-drawer__locale-form';
  const FIELDS = ['country_code', 'locale_code'];

  document.addEventListener('change', (event) => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement)) return;
    if (!FIELDS.includes(select.name)) return;

    const form = select.closest(FORMS);
    if (!form) return;

    /* One navigation per interaction : a second change while the POST is in
       flight would fire a competing submit. Never disable the selects here -
       a disabled control is left out of the payload. */
    if (form.dataset.pmSubmitting) return;
    form.dataset.pmSubmitting = '1';

    form.submit();
  });
})();
